import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { MerchCardTitleContainer } from '../../../../v2/containers/merch-card/headings-display/MerchCardTitleContainer';
import { jsx as _jsx } from "react/jsx-runtime";
export const renderTitle = ({
  productLevel,
  showProductLevelTitle
}) => {
  switch (productLevel) {
    case 'STARTER':
      return showProductLevelTitle ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "merchCards.starterCard.title.productLevelTitle"
      }) : /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "pricing-pages-ui.merchCardsV2.customerPlatform.starterCard.title"
      });
    case 'PROFESSIONAL':
      return showProductLevelTitle ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "merchCards.professionalCard.title.productLevelTitle"
      }) : /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "pricing-pages-ui.merchCardsV2.customerPlatform.professionalCard.title"
      });
    case 'ENTERPRISE':
      return showProductLevelTitle ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "merchCards.enterpriseCard.title.productLevelTitle"
      }) : /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "pricing-pages-ui.merchCardsV2.customerPlatform.enterpriseCard.title"
      });
    default:
      return undefined;
  }
};
export const SuiteCardTitle = ({
  productLevel,
  showProductLevelTitle = false
}) => {
  return /*#__PURE__*/_jsx(MerchCardTitleContainer, {
    Title: renderTitle({
      productLevel,
      showProductLevelTitle
    })
  });
};